import { ActionIcon } from '@mantine/core';
import { IconFileTypePdf, IconFileTypeXml } from '@tabler/icons-react';
import classNames from 'classnames/bind';
import { invoiceActions } from 'store/invoice/invoice.actions';
import type { OnClickFunction } from 'types/html-type';
import type { CreditNote } from 'types/store/credit-note-state';
import type { Invoice } from 'types/store/invoice-state';

import styleIdentifiers from './downloadInvoice.module.scss';

const styles = classNames.bind(styleIdentifiers);

type Props = {
  hasUbl: boolean;
  invoice: Partial<Invoice> | Partial<CreditNote>;
  importOriginalInvoice: OnClickFunction;
};

export default function DownloadInvoice({ invoice, hasUbl, importOriginalInvoice }: Props) {
  if (!invoice?.id) return null;

  const handleDownload = () => invoiceActions.document({ id: invoice.id, type: 'invoice_ubl' });

  return (
    <div className={styles('DownloadInvoice')}>
      <ActionIcon size="xl" variant="transparent" onClick={importOriginalInvoice}>
        <IconFileTypePdf stroke={1.5} size={30} />
      </ActionIcon>
      {hasUbl && (
        <ActionIcon size="xl" variant="transparent" onClick={handleDownload}>
          <IconFileTypeXml stroke={1.5} size={30} />
        </ActionIcon>
      )}
    </div>
  );
}
